import {toast} from 'react-toastify';
import React, {FC} from 'react';
import {Button} from './Buttons';

interface ICopyFieldProps {
  label: string;
  value: string;
  hint?: string;
  /** Renders the value in a pre block (for JSON and shell snippets) instead of a single truncating line. */
  multiline?: boolean;
}

export const CopyField: FC<ICopyFieldProps> = ({label, value, hint, multiline = false}) => {
  const copy = () =>
    navigator.clipboard
      .writeText(value)
      .then(() => toast.success(`${label} copied`))
      .catch((e) => console.log('Error copying to clipboard', e));

  return (
    <div className="mb-4">
      <div className="mb-1 text-[13px] font-medium text-[#33364b]">{label}</div>
      <div className={`flex gap-2 ${multiline ? 'items-start' : 'items-stretch'}`}>
        {multiline ? (
          <pre className="m-0 min-w-0 flex-1 overflow-x-auto whitespace-pre rounded-md border border-[#dcdee5] bg-[#f7f7f9] px-3 py-2 font-mono text-[12px] leading-relaxed text-[#33364b]">
            {value}
          </pre>
        ) : (
          <div className="h-8 min-w-0 flex-1 truncate rounded-md border border-[#dcdee5] bg-[#f7f7f9] px-3 font-mono text-[12px] leading-[30px] text-[#33364b]">
            {value}
          </div>
        )}
        <Button size="small" variant="secondary" label="Copy" onClick={copy} />
      </div>
      {hint && <div className="mt-1 text-[12px] text-gray-500">{hint}</div>}
    </div>
  );
};
